// extracted by mini-css-extract-plugin
module.exports = {"Ul_horizontal":"navigation_items_Ul_horizontal__3ho8m","Ul_vertical":"navigation_items_Ul_vertical__2Kssm"};